import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f9eea5e&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9eea5e')) {
      api.createRecord('0f9eea5e', component.options)
    } else {
      api.reload('0f9eea5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f9eea5e&", function () {
      api.rerender('0f9eea5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/index.vue"
export default component.exports